/** Shared RU copy preset for web/admin; apps pass explicitly as override (ADR-025). */
export const RU_ERROR_MESSAGE_OVERRIDES = {
    statusMessages: {
        400: 'Некорректные данные запроса',
        401: 'Необходима авторизация',
        403: 'Недостаточно прав доступа',
        404: 'Ресурс не найден',
        429: 'Слишком много запросов. Попробуйте позже',
        500: 'Ошибка сервера',
        502: 'Сервер временно недоступен',
        503: 'Сервис временно недоступен',
    },
    networkError: 'Ошибка сетевого соединения',
    unknownError: 'Произошла неизвестная ошибка',
    authEventMessage: 'Сессия истекла, необходима повторная авторизация',
    serverErrorTitle: 'Ошибка сервера',
    serverErrorMessage: 'Произошла ошибка на сервере. Попробуйте позже.',
    clientErrorTitle: 'Ошибка',
};
